module.exports = __webpack_public_path__ + "static/media/3s_bis_05.3927fac6.png";